import React, {PureComponent} from 'react';

class Page extends PureComponent {
  constructor(props){
    super(props);
    this.state = {};
  }
  handleOnClick(){
    this.props.handleOnClick(this.props.num);
  }
  render(){
    const {
      isActive, num
    } = this.props;
    const classes = isActive ? 
                    "nav-item page is-selected"
                     : "nav-item page";

    return  <li onClick={this.handleOnClick.bind(this)}
                className={classes}>{num}</li>
  }
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/pagination/Page.js